import styled from 'styled-components';

export const StyledToast = styled.div`
  background-color: ${(p) => p.theme.alias.fg};
  width: fit-content;
  color: ${(p) => p.theme.alias.bg};
  margin: ${(p) => p.theme.space[3]} ${(p) => p.theme.space[0]};
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[5]};
  border-radius: ${(p) => p.theme.radii.pill};
`;
